export default "__VITE_ASSET__CgE$k7zq__"